import { ExternalLink } from 'lucide-react';
import logoDL from '@/assets/logo-dzialaj-lokalnie.webp';
import logoPAFW from '@/assets/logo-pafw.png';
import logoAkademia from '@/assets/logo-akademia.webp';
import gminaLisewo from '@/assets/gmina-lisewo.png';
import gminaChelmza from '@/assets/gmina-chelmza.png';
import gminaGrudziadz from '@/assets/gmina-grudziadz.png';
import gminaKsiazki from '@/assets/gmina-ksiazki.png';
import powiatChelmno from '@/assets/powiat-chelmno.png';
import wojKujawskoPomorskie from '@/assets/woj-kujawsko-pomorskie.png';

const strategic = [
  { name: 'Działaj Lokalnie', url: 'https://www.dzialajlokalnie.pl', logo: logoDL },
  { name: 'PAFW', url: 'https://www.pafw.pl', logo: logoPAFW },
  { name: 'Akademia Rozwoju Filantropii', url: 'https://www.filantropia.org.pl', logo: logoAkademia },
  { name: 'Gmina Lisewo', url: 'https://www.lisewo.com', logo: gminaLisewo },
];

const odlWithLogos = [
  { name: 'Gmina Grudziądz (wiej.)', url: 'https://www.grudziadz.gmina.pl', logo: gminaGrudziadz },
  { name: 'Gmina Chełmża (wiej.)', url: 'https://www.gminachelmza.pl', logo: gminaChelmza },
  { name: 'Gmina Książki', url: 'https://www.gminaksiazki.pl/', logo: gminaKsiazki },
];

const other = [
  { name: 'Starostwo Powiatowe w Chełmnie', url: 'https://www.powiat-chelmno.pl', logo: powiatChelmno },
  { name: 'Urząd Marszałkowski Woj. Kujawsko-Pomorskiego', url: 'https://www.kujawsko-pomorskie.pl', logo: wojKujawskoPomorskie },
];

const PartnerCard = ({ name, url, logo }: { name: string; url: string; logo: string }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    className="bg-card rounded-lg p-4 border hover:border-secondary hover:shadow-sm transition-all flex items-center gap-3 group"
  >
    <img src={logo} alt={name} className="h-10 w-10 object-contain flex-shrink-0 rounded" loading="lazy" />
    <span className="font-medium text-sm group-hover:text-secondary transition-colors">{name}</span>
    <ExternalLink className="w-3 h-3 text-muted-foreground flex-shrink-0 ml-auto" />
  </a>
);

const PartnersSection = () => {
  return (
    <section id="partnerzy" className="py-16 lg:py-24 bg-muted/50">
      <div className="container">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-10 text-center">Partnerzy</h2>

        <div className="mb-8">
          <p className="text-sm font-semibold text-secondary uppercase tracking-wider mb-4">Partnerzy strategiczni</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {strategic.map((p) => <PartnerCard key={p.name} {...p} />)}
          </div>
        </div>

        <div className="mb-8">
          <p className="text-sm font-semibold text-secondary uppercase tracking-wider mb-4">Gminy ODL</p>
          <div className="grid sm:grid-cols-3 gap-4">
            {odlWithLogos.map((p) => <PartnerCard key={p.name} {...p} />)}
          </div>
        </div>

        <div>
          <p className="text-sm font-semibold text-secondary uppercase tracking-wider mb-4">Pozostali partnerzy</p>
          <div className="grid sm:grid-cols-2 gap-4">
            {other.map((p) => <PartnerCard key={p.name} {...p} />)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
